import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region BALANCE

function _Balance(props) {
    const data = props.data || {};
    const blockProps = props.config && props.config.config && props.config.config.Block || {};
    let hasValue;
    if (blockProps.includeNoPayments || (!blockProps.includeNoPayments && data.Payments && data.Payments.length > 0)) {
        hasValue = true;
    }
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Balance = withLabelTokenParsing(_Balance, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Balance:
            if (data.ExchangeRate && data.ExchangeRate.Balance != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Balance, options);
            }
            break;
        case Token.Total.Balance:
            if (data.Balance != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Balance, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Balance', defaultValue, Token.Total.Balance),
        Token.getWrappedTokenConfig('Balance (Display Currency)', Token.DisplayCurrency.Balance)
    ];
};
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block(2, [{
            display: 'Display if no payment(s)',
            fullWidth: true,
            group: 'block',
            name: 'includeNoPayments',
            type: 'checkbox',
            value: true
        }]),
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Balance' })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Balance}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Balance }))
    }
};

// #endregion BALANCE

export {
    Balance as Component,
    Tokens,
    TypeConfig
}